import { EventBus } from "OK/EventBus";
import { Theme } from "OK/ThemeEnum";

export interface IThemeChange {
    oldValue: Theme;
    newValue: Theme;
}

export const ThemeEventBusesPrefix = 'ui.theme';

const create = EventBus.factory(ThemeEventBusesPrefix);

export const THEME_CHANGE = create<IThemeChange>('change');
